import { Box, useMediaQuery, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setPosts } from "state";
import Navbar from "scenes/navbar";
import PostsWidget from "scenes/widgets/PostsWidget";
import UserWidget from "scenes/widgets/UserWidget";
import AdvertWidget, { img1 as advertImage } from "scenes/widgets/AdvertWidget";
import { preloadImages } from "utils/imageUtils";
import { BASE_URL } from "../../config";

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { userId } = useParams();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const isNonMobileScreens = useMediaQuery("(min-width:1000px)");

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      // 1. Fetch User
      const userPromise = fetch(`${BASE_URL}/users/${userId}`, {
        method: "GET",
        headers: headers,
      }).then((res) => res.json());

      // 2. Fetch User Posts
      const postsPromise = fetch(`${BASE_URL}/posts/${userId}/posts`, {
        method: "GET",
        headers: headers,
      }).then((res) => res.json());

      const [userData, postsData] = await Promise.all([userPromise, postsPromise]);

      setUser(userData);
      dispatch(setPosts({ posts: postsData }));

      // 3. Preload Images
      const imagesToLoad = [];

      // Advert (if exists)
      if (advertImage) imagesToLoad.push(advertImage);

      // User Avatar
      if (userData.picturePath) imagesToLoad.push(userData.picturePath);

      // Friends' Avatars
      if (Array.isArray(userData.friends)) {
        userData.friends.forEach((friend) => {
          if (friend.picturePath) imagesToLoad.push(friend.picturePath);
        });
      }

      // Posts Images & User Avatars in posts
      if (Array.isArray(postsData)) {
        postsData.forEach((post) => {
          if (post.picturePath) imagesToLoad.push(post.picturePath);
          if (post.userPicturePath) imagesToLoad.push(post.userPicturePath);
          if (Array.isArray(post.comments)) {
            post.comments.forEach((comment) => {
              if (comment.userPicturePath) imagesToLoad.push(comment.userPicturePath);
            });
          }
        });
      }

      await preloadImages(imagesToLoad);

    } catch (error) {
      console.error("Failed to load profile page data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [userId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <Navbar />
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="calc(100vh - 6rem)"
          bgcolor="background.default"
        >
          <CircularProgress size="4rem" />
        </Box>
      ) : (
        <Box
          width="100%"
          padding="1rem 3%"
          display={isNonMobileScreens ? "flex" : "block"}
          // gap="0.5rem"
          justifyContent="space-between"
        >
          <Box flexBasis={isNonMobileScreens ? "26%" : undefined}>
            <UserWidget userId={userId} picturePath={user.picturePath} isAuth={Boolean(token)} userData={user} />
          </Box>
          <Box
            flexBasis={isNonMobileScreens ? "42%" : undefined}
            mt={{ xs: "1rem", md: "0" }}
          // mt={isNonMobileScreens ? undefined : "2rem"}
          >
            {/* MyPostWidget is hidden on profile page */}
            <PostsWidget userId={userId} isProfile shouldFetch={false} />
          </Box>
          {isNonMobileScreens && (
            <Box flexBasis="26%">
              <AdvertWidget />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ProfilePage;